import { AxiosResponse } from 'axios';
import {
  Conversation,
  IConversationItem,
  IExternalTranscription,
  IVideoResponse
} from '../model';
import { tavusHttpService } from 'shared/api';
import { ITMessageDaily } from 'shared/model';

const tavusConversationsEndpoint = '/conversations/';

let startTimerCalled = false;
let callStarted = false;

export const conversationApi = {
  createConversation: async ({
    personaId,
    key,
    language,
    preconversationId,
    data
  }: {
    personaId: string;
    key: string | undefined;
    language?: string;
    preconversationId?: string | null;
    data?: {
      [key: string]: string;
    };
  }) => {
    const response = await tavusHttpService.post<Conversation>(
      `${tavusConversationsEndpoint}start/${personaId}`,
      data,
      {
        headers: {
          'x-api-key': key
        },
        params: {
          language,
          preconversation_id: preconversationId
        }
      }
    );

    return response.data;
  },

  startTimerOnce: async (
    conversationId: string,
    startTime: string,
    key?: string
  ) => {
    if (startTimerCalled) return;
    startTimerCalled = true;

    try {
      const { data } = await tavusHttpService.post(
        `${tavusConversationsEndpoint}${conversationId}/set-start-stream-time`,
        null,
        {
          params: {
            start_time: startTime
          },
          headers: {
            'x-api-key': key
          }
        }
      );
      return data;
    } catch (error) {
      startTimerCalled = false;
      throw error;
    }
  },

  initiateCallOnce: async (callFunction: () => Promise<void>) => {
    if (callStarted) return;
    callStarted = true;

    try {
      await callFunction();
    } catch (err) {
      callStarted = false;
      throw err;
    }
  },

  downloadVideo: async (conversationId: string) => {
    const { data } = await tavusHttpService.get<IVideoResponse>(
      `${tavusConversationsEndpoint}video/${conversationId}`
    );
    return data;
  },

  endConversation: async (
    conversationId: string,
    messages: ITMessageDaily[],
    emotionalTimeline: string,
    key?: string
  ) => {
    messages = messages.map((message) => ({
      ...message,
      user_name: message.userName
    }));

    const data: AxiosResponse<any> = await tavusHttpService.post(
      `${tavusConversationsEndpoint}${conversationId}/end`,
      {
        messages,
        emotional_timeline: emotionalTimeline,
        stream_ended_at: new Date().toISOString()
      },
      {
        headers: {
          'x-api-key': key
        }
      }
    );

    return data;
  },

  fetchAll: async (personaId: string) => {
    const { data } = await tavusHttpService.get<IConversationItem[]>(
      `${tavusConversationsEndpoint}persona/${personaId}`
    );
    return data;
  },

  getTranscriptions: async (conversationId: string) => {
    const { data } = await tavusHttpService.get<IExternalTranscription[]>(
      `${tavusConversationsEndpoint}transcriptions/${conversationId}`
    );
    return data;
  },

  resetTimers: () => {
    startTimerCalled = false;
    callStarted = false;
  }
};
